var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleKubernetesEngine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4285f4;}.cls-1,.cls-2,.cls-4{fill-rule:evenodd;}.cls-2{fill:#669df6;}.cls-3,.cls-4{fill:#aecbfa;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_24px_K8Engine_Color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Product Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.68 13.06 19.23 15.69 19.23 16.68 14.29 13.83 14.68 13.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.98 13.65 4.77 16.66 4.45 15.86 9.53 12.92 9.98 13.65"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 11.55,
    y: 3.29,
    width: 0.86,
    height: 5.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3.25,7V17L12,22l8.74-5V7L12,2Zm15.63,8.89L12,19.78,5.12,15.89V8.11L12,4.22l6.87,3.89v7.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "11.98 11.5 15.96 9.21 11.98 6.91 8.01 9.21 11.98 11.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.52 12.3 7.66 10.01 7.66 14.6 11.52 16.89 11.52 12.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "12.48 12.3 12.48 16.89 16.34 14.6 16.34 10.01 12.48 12.3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleKubernetesEngine);
export default __webpack_public_path__ + "static/media/google_kubernetes_engine.f254cf1a828ecc0be840554859f338ee.svg";
export { ForwardRef as ReactComponent };